import { seoResolver } from "../../modules/app-route";
import { AppRoutes } from "../../modules/app-route/models/app-route.model";

export const JUGEND_ROUTES: AppRoutes = [
    {
        path: "",
        loadComponent: () => import('./components/jugend-carousel/jugend-carousel.component').then(mod => mod.JugendCarouselComponent),
        outlet: "carousel"
    },
    {
        path: "",
        loadComponent: () => import('./components/jugend-home/jugend-home.component').then(mod => mod.JugendHomeComponent),
        title: 'YSTM - Jugend',
        data: {
            meta: {
                description: 'regelmäßiges Opti-Training; Segeln mit unseren Clubbooten: Optimist, Auswanderer, Laser; Tretboot-Fahren, geheime Buchten ansteuern, Schwimmen und Klettertouren; Jugendfahrten, Segelcamp'
            }
        },
        resolve: { seo: seoResolver },
    },
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full'
    }
];